import { render } from "./TicketDetail.vue?vue&type=template&id=f7aea2be&scoped=true"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"

import "./TicketDetail.vue?vue&type=style&index=0&id=f7aea2be&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_ambient/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7aea2be"]])

export default __exports__